var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutputPower = function SvgOutputPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#outputPower_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.62 6h6.856v6.857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.476 6-9.686 9.686a.857.857 0 0 1-1.2 0l-3.942-3.943a.857.857 0 0 0-1.2 0L1.19 18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "outputPower_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h24v24h-24z"
  })))));
};
export default SvgOutputPower;